<template>
	<h1 v-if="display_title" class="image-title">{{ title }}</h1>
	<div class="d-flex justify-content-center h-100">
		<img class="d-block img-fluid m-auto" style="height: 750px;" :src="url" loading="lazy" />
	</div>
	<h1 class="image-description">{{ description }}</h1>
</template>

<script>
export default {
	name: "GalleryLayout1",
	props: {
		title: String,
		display_title: Boolean,
        url: String,
		description: String,
	}
};
</script>

<style scoped>

.image-title {
	position: absolute;
	top: 40px;
	text-align: center;
	left: 50px;
	right: 50px;
	color: #fff;
	font-size: 3.5em;
}
.image-description {
	position: absolute;
	left: 50px;
	right: 50px;
	text-align: center;
	bottom: 50px;
	color: #fff;
}
</style>